import { render } from "./logoff.vue?vue&type=template&id=8abea8dc&scoped=true&ts=true"
import script from "./logoff.vue?vue&type=script&lang=ts"
export * from "./logoff.vue?vue&type=script&lang=ts"

import "./logoff.vue?vue&type=style&index=0&id=8abea8dc&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8abea8dc"]])